export const PERIOD_TYPE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
}

export const PERIOD_TYPE_DATA = [
  {
    label: 'score.main.YEARLY',
    value: 'Yearly',
    isI18n: true,
  },
  {
    label: 'score.main.QUARTERLY',
    value: 'Quarterly',
    isI18n: true,
  },
  {
    label: 'score.main.MONTHLY',
    value: 'Monthly',
    isI18n: true,
  },
]

export const SCORE_COLORS = [
  {
    color: '#EB6671',
    id: 5,
  },
  {
    color: '#F38C6B',
    id: 4,
  },
  {
    color: '#FFDE86',
    id: 3,
  },
  {
    color: '#C3D785',
    id: 2,
  },
  {
    color: '#87D4A4',
    id: 1,
  },
  {
    color: '#CCC',
    id: 0,
  },
]

//credit
export const SCORE_COLORS_ID = {
  5: '#EB6671',
  4: '#F38C6B',
  3: '#FFDE86',
  2: '#C3D785',
  1: '#87D4A4',
  0: '#CCC',
}

//Performance
export const SCORE_PERFORMANCE_COLORS_ID = {
  4: '#EB6671',
  3: '#FFDE86',
  2: '#C3D785',
  1: '#87D4A4',
  0: '#CCC',
}

export const SCORE_COLORS_PERFORMANCE = [
  {
    color: '#EB6671',
    id: 4,
  },
  {
    color: '#FFDE86',
    id: 3,
  },
  {
    color: '#C3D785',
    id: 2,
  },
  {
    color: '#87D4A4',
    id: 1,
  },
  {
    color: '#CCC',
    id: 0,
  },
]
